import { getTheme, IStackStyles, ITextStyles, Separator, Stack, StackItem, Text } from '@fluentui/react';
import React from 'react';
import { QueueConfiguration } from '../../../services';
import { BaseTab } from './BaseTab';
import {
  separatorStyle,
  numericalSpacingStackTokens,
  textWrapperStyle,
  titleTextWrapperStyle
} from '../SettingsStyles';
import { DisplayNameField } from '../DisplayNameField';
import { ConfigCheckbox } from '..';
import { TooltipText } from '../../shared';
import { FieldSectionComponent } from '../FieldSectionComponent';
import { AdminContext } from '../../../Store/Admin';

const gridItemStyle: IStackStyles = {
  root: {
    overflow: 'visible',
    minWidth: 'calc(90% / 2)',
    marginRight: 14
  }
};

interface DetailFieldProps {
  title: string;
  subtitle: string;
}

const DetailField: React.FC<DetailFieldProps> = props => {
  const { palette } = getTheme();

  const randomname: ITextStyles = {
    root: {
      color: palette.black,
      fontWeight: 900
    }
  };

  const textStyle: ITextStyles = {
    root: {
      color: palette.neutralDark
    }
  };

  return (
    <StackItem styles={gridItemStyle} shrink={0}>
      <div className="mb-4">
        <Stack horizontal horizontalAlign="space-between" tokens={numericalSpacingStackTokens}>
          <Stack styles={titleTextWrapperStyle} tokens={{ childrenGap: 5 }}>
            <Stack.Item>
              <Text className="ms-sm12 ms-md12 font-weight-bold" variant={'mediumPlus'} styles={randomname}>
                {props.title}
              </Text>
            </Stack.Item>
            <Stack.Item styles={textWrapperStyle}>
              <Text className="ms-sm12 ms-md12" variant={'medium'} styles={textStyle}>
                {props.subtitle}
              </Text>
            </Stack.Item>
          </Stack>
        </Stack>
      </div>
    </StackItem>
  );
};

interface OverviewTabProps {
  queueData: QueueConfiguration;
}

export const OverviewTab: React.FC<OverviewTabProps> = props => {
  const { palette } = getTheme();
  const { state } = React.useContext(AdminContext);

  return (
    <BaseTab>
      <Text as={'h2'} className="my-2" variant={'xLarge'}>
        {'Queue details'}
      </Text>
      <Stack style={{ display: 'flex', flexFlow: 'row wrap' }}>
        <DisplayNameField
          id={'displayName'}
          label={'Display Name'}
          tooltip={'The name of your queue'}
          aria-labelledby={'The name of your queue'}
          styles={gridItemStyle}
        />
        <DetailField title={'Queue ID'} subtitle={props.queueData.id} />
        <DetailField title={'Title display name'} subtitle={props.queueData.title.displayName} />
        <DetailField title={'Title ID'} subtitle={props.queueData.title.titleId} />
        <DetailField title={'Content Type'} subtitle={props.queueData.contentType} />
      </Stack>
      <Separator styles={separatorStyle(palette)} />
      <Text as={'h2'} className="my-2" variant={'xLarge'}>
        {'Tenant details'}
      </Text>
      <Stack style={{ display: 'flex', flexFlow: 'row wrap' }}>
        <DetailField title={'Tenant display name'} subtitle={props.queueData.tenant.displayName} />
        <DetailField title={'Tenant ID'} subtitle={props.queueData.tenant.tenantId} />
      </Stack>
      <Separator styles={separatorStyle(palette)} />

      <FieldSectionComponent
        id={'NotAssignableTitle'}
        title={TooltipText.subtitleNotAssignable}
        body={TooltipText.configNotAssignable}
      >
        <Stack.Item>
          {state.queueDataState && (
            <ConfigCheckbox
              className="text-center ms-Grid-col ms-sm12 ms-md12 font-weight-bold"
              tooltip={''}
              id="NOT_ASSIGNABLE"
              label="Don't Allow"
              describedBy="NotAssignableTitle"
              value={state.queueDataState.notAssignable}
            />
          )}
        </Stack.Item>
      </FieldSectionComponent>
    </BaseTab>
  );
};
